export const FORM_ID = 'newMeeting-form';
export const NAME_MAX_LENGTH = 35;
export const NAME_MIN_LENGTH = 2;
